//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmBlank from '@/components/cmBlank';
import cmLoadmore from '@/components/cmLoadmore.vue'

export default {
     components: {
        cmBlank,cmLoadmore
    },
    data(){
        return {
            pop:false,
            blankShow:false,
            loadStatus:false,
            loadmoreText:'正在加载。。。',
            busy:false,
            list:[],
            hasNext:0,
            pageFlag:2,
            lastId:0,
            couponId:0,
            checkAllStatus:false,
            allText:'全选',
            ids:'',
            days:'',
            number:'',
            phone:'',
        }
    },
    created() {
        this.couponId = Number(this.$route.params.id);
    },
    mounted(){
       
    },
    methods: {
        search(){
            this.list = [];
            this.lastId = 0;
            this.hasNext = 0;
            this.getList();
        },
        getList(){
            this.$api.getCommunityUser({last_id:this.lastId,page_flag:this.pageFlag,phone:this.phone}).then((res)=>{
                if(res){
                    if(!this.lastId){
                        this.blankShow = res.data.length > 0 ? false : true;
                    }
                    this.hasNext = res.hasNext;
                    this.lastId = res.lastId;
                    res.data.forEach((item)=>{
                        this.list.push(item);
                    });
                }
            })  
        },
        check(i){
            if(this.list[i].checked > 0){
                this.list[i].checked = 0;
            }else{
                this.list[i].checked = 1;
            }
        },
        checkAll(){
            this.checkAllStatus = !this.checkAllStatus;
            if(this.checkAllStatus){
                this.list.forEach((item,index)=>{
                    item.checked = 1;
                })
                this.allText = '全不选';
            }else{
                this.list.forEach((item,index)=>{
                    item.checked = 0;
                })
                this.allText = '全选';
            }
        },
        showPop(){
            this.ids = '';
            this.list.forEach((item,index) => {
                if(item.checked){
                    this.ids += item.uid+',';
                }
            });
            if(!this.ids){
                this.$func.showToast('请选择用户');
                return false;
            }
            this.pop = true;
        },
        give(){
            if(this.number <= 0){
                this.$func.showToast('请输入赠送数量');
                return false;
            }
            console.log({coupon_id:this.couponId,ids:this.ids});
            this.$func.confirm('确认赠送？','提示',()=>{
                this.$api.giveCoupon({coupon_id:this.couponId,ids:this.ids,number:this.number,days:this.days}).then((res)=>{
                    if(res){
                        this.$func.showToast('提交成功');
                        this.pop = false;
                        this.phone = '';
                        this.search();
                    } 
                })  
            })
        },
        closePop(){
            this.pop = false;
        },
         loadmore(){
            if(this.lastId > 0 && !this.hasNext){
                this.busy = true;
                this.loadStatus = true;
                this.loadmoreText = '没有更多了。。。'
                return ;
            }
            this.busy = true;
            this.loadStatus = true;
            this.loadmoreText = '正在加载。。。';
            console.log(1111);
            this.getList();
            setTimeout(()=>{
            if(this.blankShow){
                    this.busy = true;
                    this.loadStatus = false;
                    this.loadmoreText = '没有更多了。。。'
                }else{
                    if(this.hasNext > 0){
                        this.loadStatus = false;
                        this.busy = false;
                    }else{
                        this.busy = true;
                        this.loadStatus = true;
                        this.loadmoreText = '没有更多了。。。'
                    }
                }
            },1500)
        }
    },
}



// WEBPACK FOOTER //
// ./src/pages/giveCoupon.vue